import React from 'react';
import { useGetInventoryStatus } from '../../api/hooks/inventory';
import Table from '../common/table';
import { Box } from '@mui/material';

export default function InventoryTable() {
  const { data: records } = useGetInventoryStatus();

  return (
    <Box sx={{ width: '100%', maxHeight: 300 }}>
      <Table
        columns={columns}
        rows={sortInventory(records)}
        keys={['owner_name', 'color_name', 'model_name']}
      />
    </Box>
  );
}

const columns = [
  {
    id: 'owner_name',
    label: 'مالک',
    minWidth: 150,
  },

  {
    id: 'model_name',
    label: 'نام مدل',
    minWidth: 100,
  },

  {
    id: 'model_memory',
    label: 'حافظه',
    minWidth: 30,
    format: (count) => Number(count).toLocaleString('fa-IR'),
  },
  {
    id: 'model_ram',
    label: 'رم',
    minWidth: 30,
    format: (count) => Number(count).toLocaleString('fa-IR'),
  },

  {
    id: 'color_name',
    label: 'رنگ',
    minWidth: 40,
  },
  {
    id: 'count',
    label: 'موجودی',
    minWidth: 40,
    format: (count) => Number(count).toLocaleString('fa-IR'),
  },
];

const sortInventory = (inventory) =>
  inventory
    ?.sort((a, b) => (a.owner_name > b.owner_name ? 1 : -1))
    ?.sort((a, b) => a.count - b.count)
    ?.sort((a, b) =>
      `${a.model_name}${a.ram}${a.storage}` > `${b.model_name}${b.ram}${b.storage}` ? 1 : -1
    );
